import { useTranslation } from 'react-i18next';
import { Form } from '@anytag/shared-atoms';
import { ToggleOption } from '@anytag/shared-types';
import { RadiosField, RadiosFieldProps } from '@anytag/shared-molecules';
import { MarketplaceFormKeys } from '../types';

type ApprovePostsFieldProps = Pick<RadiosFieldProps, 'className' | 'disabled' | 'required'>;
export const ApprovePostsField = ({ className, ...restProps }: ApprovePostsFieldProps) => {
  const { t } = useTranslation();

  const options = [
    { value: ToggleOption.FALSE, label: t('Disable Multi-Posting') },
    { value: ToggleOption.TRUE, label: t('Enable Multi-Posting') }
  ];

  return (
    <Form.Field className={className}>
      <p css={{ fontWeight: 600, fontSize: '14px', marginBottom: '16px' }}>
        {t('Choose whether to enable Multi-Posting for creator')}
      </p>
      <RadiosField
        itemsPerRow={2}
        options={options}
        css={{ padding: 0, fontSize: '14px' }}
        name={MarketplaceFormKeys.isAllowMultiplePosts}
        {...restProps}
      />
    </Form.Field>
  );
};
